import React from 'react';
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import Cookies from 'universal-cookie';
import GetProxy from '../../../common/GetProxy';
import { handleResponseCode } from '../../../../app/utilities/helpers';
const proxy = GetProxy();
const cookies = new Cookies();

export const CCIPlatformApiCall = createAsyncThunk(
    "post/CCIPlatformApiCall",
    async (props) => {
        const apiToken = cookies.get("apitoken");
        const username = cookies.get("username");
        try {
            const { payload } = props;
            const response = await fetch(`${proxy}/api/v1/costOverView/fetchCostDetails`,
                {
                    method: "POST",
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        "CMTS-API-TOKEN": apiToken,
                        USERNAME: username,
                    },
                    body: JSON.stringify(payload),
                }
            );
            handleResponseCode(response);
            const data = await response.json();

            return response.ok ? data : Promise.reject(data);
        } catch (error) {
            throw error;
        }
    }
)

export const CCIConsolidatedApiCall = createAsyncThunk(
    "post/CCIConsolidatedApiCall",
    async (props) => {
        const apiToken = cookies.get("apitoken");
        const username = cookies.get("username");
        try {
            const { payload } = props;
            const response = await fetch(`${proxy}/api/v1/costOverView/fetchPlatformCostDetails`,
                {
                    method: "POST",
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        "CMTS-API-TOKEN": apiToken,
                        USERNAME: username,
                    },
                    body: JSON.stringify(payload),
                }
            );
            handleResponseCode(response);
            const data = await response.json();

            return response.ok ? data : Promise.reject(data);
        } catch (error) {
            throw error;
        }
    }
)
export const CCIApplicationApiCall = createAsyncThunk(
    "post/CCIApplicationApiCall",
    async () => {
        const Apitoken = cookies.get("apitoken");
        const User = cookies.get("username");
        try {
            const response = await fetch(
                `${proxy}/api/v1/costOverViewSummary/fetchApplicationCost`,
                {
                    method: "GET",
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        "CMTS-API-TOKEN": Apitoken,
                        USERNAME: User,
                    },
                }
            );
            handleResponseCode(response);
            const data = await response.json();
            return response.ok ? data : Promise.reject(data);
        } catch (error) {
            console.error("Error:", error);
            throw error;
        }
    }
)
export const CCICStackCostApiCall = createAsyncThunk(
    "post/CCICStackCostApiCall",
    async () => {
        const Apitoken = cookies.get("apitoken");
        const User = cookies.get("username");
        try {
            const response = await fetch(
                `${proxy}/api/v1/costOverViewSummary/fetchCStackCost`,
                {
                    method: "GET",
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        "CMTS-API-TOKEN": Apitoken,
                        USERNAME: User,
                    },
                }
            );
            handleResponseCode(response);
            const data = await response.json();
            return response.ok ? data : Promise.reject(data);
        } catch (error) {
            console.error("Error:", error);
            throw error;
        }
    }
)
export const CCIGCCCostApiCall = createAsyncThunk(
    "post/CCIGCCCostApiCall",
    async () => {
        const Apitoken = cookies.get("apitoken");
        const User = cookies.get("username");
        try {
            const response = await fetch(
                `${proxy}/api/v1/costOverViewSummary/fetchGCCCost`,
                {
                    method: "GET",
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        "CMTS-API-TOKEN": Apitoken,
                        USERNAME: User,
                    },
                }
            );
            handleResponseCode(response);
            const data = await response.json();
            return response.ok ? data : Promise.reject(data);
        } catch (error) {
            console.error("Error:", error);
            throw error;
        }
    }
)
export const CCIContainerCostApiCall = createAsyncThunk(
    "post/CCIContainerCostApiCall",
    async () => {
        const Apitoken = cookies.get("apitoken");
        const User = cookies.get("username");
        try {
            const response = await fetch(
                `${proxy}/api/v1/costOverViewSummary/fetchContainerCost`,
                {
                    method: "GET",
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        "CMTS-API-TOKEN": Apitoken,
                        USERNAME: User,
                    },
                }
            );
            handleResponseCode(response);
            const data = await response.json();
            return response.ok ? data : Promise.reject(data);
        } catch (error) {
            console.error("Error:", error);
            throw error;
        }
    }
)
export const CCIFinancialYearsApiCall = createAsyncThunk(
    "get/CCIFinancialYearsApiCall",
    async () => {
        const apiToken = cookies.get("apitoken");
        const username = cookies.get("username");
        try {
            const response = await fetch(
                `${proxy}/api/v1/costOverView/getFinancialYears`,
                {
                    method: "GET",
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        "CMTS-API-TOKEN": apiToken,
                        USERNAME: username,
                    },
                }
            );
            handleResponseCode(response);
            const data = await response.json();
            return response.ok ? data : Promise.reject(data);
        } catch (error) {
            throw error;
        }
    }
)

export const CCICloudCostFileImportApiCall = createAsyncThunk(
    "post/CCICloudCostFileImportApiCall",
    async (props, { rejectWithValue }) => {
        const apiToken = cookies.get("apitoken");
        const username = cookies.get("username");
        try {
            const { formData } = props;
            const response = await fetch(
                `${proxy}/api/v1/cloudCostFileUpload/import`,
                {
                    method: "POST",
                    headers: {
                        Accept: "application/json",
                        "CMTS-API-TOKEN": apiToken,
                        USERNAME: username,
                    },
                    body: formData,
                }
            );
            handleResponseCode(response);
            const data = await response.json();
            if (!response.ok) {
                return rejectWithValue(data);
            }
            return data;
        } catch (error) {
            throw error;
        }
    }
)

export const CCIGovTechTemplateDownloadApiCall = createAsyncThunk(
    "get/CCIGovTechTemplateDownloadApiCall",
    async () => {
        const apiToken = cookies.get("apitoken");
        const username = cookies.get("username");
        try {
            const response = await fetch(
                `${proxy}/api/v1/cloudCostFileUpload/template`,
                {
                    method: "GET",
                    headers: {
                        Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                        "CMTS-API-TOKEN": apiToken,
                        USERNAME: username,
                    },
                }
            );
            handleResponseCode(response);
            const data = await response.blob();
            return response.ok ? data : Promise.reject(data);
        } catch (error) {
            console.log("Error in downloading GovTech Template : ", error);
            throw error;
        }
    }
)

export const CCIGovTechFinancialYearsApiCall = createAsyncThunk(
    "get/CCIGovTechFinancialYearsApiCall",
    async () => {
        const apiToken = cookies.get("apitoken");
        const username = cookies.get("username");
        try {
            const response = await fetch(
                `${proxy}/api/v1/cloudCostFileUpload/financialYears`,
                {
                    method: "GET",
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        "CMTS-API-TOKEN": apiToken,
                        USERNAME: username,
                    },
                }
            );
            handleResponseCode(response);
            const data = await response.json();
            return response.ok ? data : Promise.reject(data);
        } catch (error) {
            throw error;
        }
    }
)

export const CCIGovTechComparisonListApiCall = createAsyncThunk(
    "post/CCIGovTechComparisonListApiCall",
    async (props) => {
        const apiToken = cookies.get("apitoken");
        const username = cookies.get("username");
        try {
            const { payload, pageNo = 0, pageLimit = 10 } = props;
            const response = await fetch(
                `${proxy}/api/v1/cloudCostFileUpload/list/${pageNo}/${pageLimit}`,
                {
                    method: "POST",
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        "CMTS-API-TOKEN": apiToken,
                        USERNAME: username,
                    },
                    body: JSON.stringify(payload),
                }
            );
            handleResponseCode(response);
            const data = await response.json();
            return response.ok ? data : Promise.reject(data);
        } catch (error) {
            throw error;
        }
    }
)

export const CCIMarketPlaceCostApiCall = createAsyncThunk(
    "post/CCIMarketPlaceCostApiCall",
    async () => {
        const Apitoken = cookies.get("apitoken");
        const User = cookies.get("username");
        try {
            const response = await fetch(
                `${proxy}/api/v1/costOverViewSummary/fetchMarketPlaceCost`,
                {
                    method: "GET",
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        "CMTS-API-TOKEN": Apitoken,
                        USERNAME: User,
                    },
                }
            );
            handleResponseCode(response);
            const data = await response.json();
            return response.ok ? data : Promise.reject(data);
        } catch (error) {
            console.error("Error:", error);
            throw error;
        }
    }
)



const initialState = {
    PlatformOverviewTableData: [],
    PlatformOverviewTableLoading: false,
    ConsolidatedOverviewTableData: [],
    ConsolidatedOverviewTableLoading: false,
    ApplicationOverviewData: [],
    ApplicationOverviewLoading: false,
    CStackCostOverviewData: [],
    CStackCostOverviewLoading: false,
    GCCCostOverviewData: [],
    GCCCostOverviewLoading: false,
    ContainerCostOverviewData: [],
    ContainerCostOverviewLoading: false,
    MarketPlaceCostOverviewData: [],
    MarketPlaceCostOverviewLoading: false,
    FinancialYearsData: [],
    FinancialYearsLoading: false,
    GovTechComparisonData: [],
    GovTechComparisonTotalCount: 0,
    GovTechComparisonLoading: false,
    GovTechFinancialYearsData: [],
    GovTechFinancialYearsLoading: false,
    govTechRefreshTrigger: 0,
    error: "",
    apiError: false,
};

export const CCIPlatformSlice = createSlice({
    name: 'CCIPlatformSlice',
    initialState,

    reducers: {
        resetCCIPlatformSliceData: () => {
            return initialState;
        },
        setApiError: (state, action) => {
            state.apiError = false;
        },
        triggerGovTechRefresh: (state) => {
            state.govTechRefreshTrigger += 1;
        },
    },
    extraReducers: (builder) => {
        builder

            //Overview platform
            .addCase(CCIPlatformApiCall.pending, (state, action) => {
                state.PlatformOverviewTableLoading = true;
                state.apiError = false;
            })
            .addCase(CCIPlatformApiCall.fulfilled, (state, action) => {
                state.PlatformOverviewTableData = action.payload;
                state.PlatformOverviewTableLoading = false;
                state.apiError = false;
            })
            .addCase(CCIPlatformApiCall.rejected, (state, action) => {
                state.PlatformOverviewTableLoading = false;
                state.PlatformOverviewTableData = [];
                state.error = "Something went wrong";
                state.apiError = true;
            })

            //Overview Consolidated
            .addCase(CCIConsolidatedApiCall.pending, (state, action) => {
                state.ConsolidatedOverviewTableLoading = true;
                state.apiError = false;
            })
            .addCase(CCIConsolidatedApiCall.fulfilled, (state, action) => {
                state.ConsolidatedOverviewTableData = action.payload;
                state.ConsolidatedOverviewTableLoading = false;
                state.apiError = false;
            })
            .addCase(CCIConsolidatedApiCall.rejected, (state, action) => {
                state.ConsolidatedOverviewTableLoading = false;
                state.ConsolidatedOverviewTableData = [];
                state.error = "Something went wrong";
                state.apiError = true;
            })

            //Overview Application
            .addCase(CCIApplicationApiCall.pending, (state, action) => {
                state.ApplicationOverviewLoading = true;
                state.apiError = false;
            })
            .addCase(CCIApplicationApiCall.fulfilled, (state, action) => {
                state.ApplicationOverviewData = action.payload;
                state.ApplicationOverviewLoading = false;
                state.apiError = false;
            })
            .addCase(CCIApplicationApiCall.rejected, (state, action) => {
                state.ApplicationOverviewLoading = false;
                state.ApplicationOverviewData = [];
                state.error = "Something went wrong";
                state.apiError = true;
            })

            //Overview CStack cost
            .addCase(CCICStackCostApiCall.pending, (state, action) => {
                state.CStackCostOverviewLoading = true;
                state.apiError = false;
            })
            .addCase(CCICStackCostApiCall.fulfilled, (state, action) => {
                state.CStackCostOverviewData = action.payload;
                state.CStackCostOverviewLoading = false;
                state.apiError = false;
            })
            .addCase(CCICStackCostApiCall.rejected, (state, action) => {
                state.CStackCostOverviewLoading = false;
                state.CStackCostOverviewData = [];
                state.error = "Something went wrong";
                state.apiError = true;
            })

            //Overview GCC Cost
            .addCase(CCIGCCCostApiCall.pending, (state, action) => {
                state.GCCCostOverviewLoading = true;
                state.apiError = false;
            })
            .addCase(CCIGCCCostApiCall.fulfilled, (state, action) => {
                state.GCCCostOverviewData = action.payload;
                state.GCCCostOverviewLoading = false;
                state.apiError = false;
            })
            .addCase(CCIGCCCostApiCall.rejected, (state, action) => {
                state.GCCCostOverviewLoading = false;
                state.GCCCostOverviewData = [];
                state.error = "Something went wrong";
                state.apiError = true;
            })

            //Overview Container
            .addCase(CCIContainerCostApiCall.pending, (state, action) => {
                state.ContainerCostOverviewLoading = true;
                state.apiError = false;
            })
            .addCase(CCIContainerCostApiCall.fulfilled, (state, action) => {
                state.ContainerCostOverviewData = action.payload;
                state.ContainerCostOverviewLoading = false;
                state.apiError = false;
            })
            .addCase(CCIContainerCostApiCall.rejected, (state, action) => {
                state.ContainerCostOverviewLoading = false;
                state.ContainerCostOverviewData = [];
                state.error = "Something went wrong";
                state.apiError = true;
            })

            //Overview Market Place
            .addCase(CCIMarketPlaceCostApiCall.pending, (state, action) => {
                state.MarketPlaceCostOverviewLoading = true;
                state.apiError = false;
            })
            .addCase(CCIMarketPlaceCostApiCall.fulfilled, (state, action) => {
                state.MarketPlaceCostOverviewData = action.payload;
                state.MarketPlaceCostOverviewLoading = false;
                state.apiError = false;
            })
            .addCase(CCIMarketPlaceCostApiCall.rejected, (state, action) => {
                state.MarketPlaceCostOverviewLoading = false;
                state.MarketPlaceCostOverviewData = [];
                state.error = "Something went wrong";
                state.apiError = true;
            })

            //Financial Years
            .addCase(CCIFinancialYearsApiCall.pending, (state) => {
                state.FinancialYearsLoading = true;
                state.apiError = false;
            })
            .addCase(CCIFinancialYearsApiCall.fulfilled, (state, action) => {
                state.FinancialYearsData = action.payload;
                state.FinancialYearsLoading = false;
                state.apiError = false;
            })
            .addCase(CCIFinancialYearsApiCall.rejected, (state) => {
                state.FinancialYearsLoading = false;
                state.FinancialYearsData = [];
                state.error = "Something went wrong";
                state.apiError = true;
            })

            //GovTech Financial Years
            .addCase(CCIGovTechFinancialYearsApiCall.pending, (state) => {
                state.GovTechFinancialYearsLoading = true;
                state.apiError = false;
            })
            .addCase(CCIGovTechFinancialYearsApiCall.fulfilled, (state, action) => {
                state.GovTechFinancialYearsData = Array.isArray(action.payload) ? action.payload : [];
                state.GovTechFinancialYearsLoading = false;
                state.apiError = false;
            })
            .addCase(CCIGovTechFinancialYearsApiCall.rejected, (state) => {
                state.GovTechFinancialYearsLoading = false;
                state.GovTechFinancialYearsData = [];
                state.error = "Something went wrong";
                state.apiError = true;
            })

            //GovTech Comparison list
            .addCase(CCIGovTechComparisonListApiCall.pending, (state) => {
                state.GovTechComparisonLoading = true;
                state.apiError = false;
            })
            .addCase(CCIGovTechComparisonListApiCall.fulfilled, (state, action) => {
                state.GovTechComparisonData = action.payload?.data || [];
                state.GovTechComparisonTotalCount = action.payload?.totalCount || 0;
                state.GovTechComparisonLoading = false;
                state.apiError = false;
            })
            .addCase(CCIGovTechComparisonListApiCall.rejected, (state) => {
                state.GovTechComparisonLoading = false;
                state.GovTechComparisonData = [];
                state.GovTechComparisonTotalCount = 0;
                state.error = "Something went wrong";
                state.apiError = true;
            })
    },

});

export const { resetCCIPlatformSliceData, setApiError, triggerGovTechRefresh } = CCIPlatformSlice.actions;
export default CCIPlatformSlice.reducer;
